import React, { useState } from "react";
import "./SingleListing.scss";
import { Link } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import relativeTime from "../../utilities/relativeTime";
import Review from "../Review/Review";
import { v4 as uuidv4 } from "uuid";
import DetailsModal from "../DetailsModal/DetailsModal";
import DeleteModal from "../DeleteModal/DeleteModal";

export default function SingleListing(props) {
  const onClickHandler = (e) => {
    props.setLocation({
      lat: Number(props.data.lat),
      lng: Number(props.data.lng),
    });
  };

  const [showDetails, setShowDetails] = useState(false);
  const [showReviews, setShowReviews] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const handleShowDetails = (e) => {
    setShowDetails(true);
  };
  console.log(showReviews);
  const reducedVals =
    props.data.reviews.reduce((acc, current) => {
      return acc + current.rating;
    }, 0) / props.data.reviews.length;

  return (
    <div className="single-listing">
      <div className="single-listing__wrapper">
        <img
          src={props.data.imgPath}
          alt="Sample"
          className="single-listing__image"
        />
        <div className="single-listing__info-wrap">
          <p className="single-listing__date">
            Date posted:
            {" " + relativeTime(props.data.postingDate)}
          </p>
          <h3 className="single-listing__name">{props.data.name}</h3>
          <p className="single-listing__address">{props.data.address}</p>
          <p className="single-listing__price">${props.data.price}</p>
          <p className="single-listing__rating-text">Average Rating:</p>
          <div className="single-listing__star-reviews">
            <Rating ratingValue={reducedVals} readonly={true} size={25} />(
            {props.data.reviews.length})
          </div>

          <div
            className="single-listing__wrap"
            onClick={() => setShowReviews(!showReviews)}
          >
            {" "}
            Display Reviews
          </div>
          {showReviews && (
            <div className="single-listing__review-wrap--tablet">
              <h3 className="single-listing__review-title-text">Reviews:</h3>

              {props.data.reviews.map((review) => (
                <Review data={review} key={uuidv4()} />
              ))}
            </div>
          )}
          {/* <div className="single-listing__review-wrap--tablet">
            <h3 className="single-listing__review-title-text">Reviews:</h3>

            {props.data.reviews.map((review) => (
              <Review data={review} key={uuidv4()} />
            ))}
          </div> */}
        </div>{" "}
      </div>
      <div className="single-listing__review-wrap">
        <h3 className="single-listing__review-title-text">Reviews:</h3>

        {props.data.reviews.map((review) => (
          <Review data={review} key={uuidv4()} />
        ))}
      </div>
      <div className="single-listing__icon-wrap">
        <Link to={`${props.data.id}/review`}>
          <div className="single-listing__info single-listing__icon-flex">
            <div className="single-listing__review-icon single-listing__icons"></div>
            review
          </div>
        </Link>
        <div
          className="single-listing__info single-listing__icon-flex"
          onClick={handleShowDetails}
        >
          <div
            className="single-listing__info-icon single-listing__icons "
            onClick={onClickHandler}
          ></div>
          locate
          {showDetails && (
            <DetailsModal data={props.data} setLocation={props.setLocation} />
          )}
        </div>
        <Link to={`${props.data.id}/edit/`}>
          <div className="single-listing__info single-listing__icon-flex">
            <div className="single-listing__edit-icon single-listing__icons "></div>
            edit
          </div>
        </Link>
        <div
          className="single-listing__info single-listing__icon-flex"
          onClick={() => {
            setShowDelete(true);
          }}
        >
          <div className="single-listing__delete-icon single-listing__icons "></div>
          delete
          {showDelete && (
            <DeleteModal
              updateData={props.updateData}
              data={props.data}
              closeDelete={setShowDelete}
            />
          )}
        </div>
      </div>
    </div>
  );
}
